import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { getTenantByHost } from '@pelicargo/tenants';
import { Show } from '@pelicargo/ui';
import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import { NewsBanner } from '../NewsBanner';
import { Footer } from './Footer';
import { Header } from './Header';

type Props = BoxProps & {
  title: string;
  showHeader?: boolean;
  showFooter?: boolean;
  children: ReactNode;
};

export const Page = ({ title = '', showHeader = true, showFooter = true, children, ...rest }: Props) => {
  return (
    <>
      <Helmet>
        <title>
          {title} | {getTenantByHost().name}
        </title>
      </Helmet>
      <Flex minH="100vh" h="full" direction="column" position="relative" bgColor="bg.default">
        <Show if={showHeader}>
          <Header />
          <NewsBanner />
        </Show>
        <Box flex="1" overflowY="auto" {...rest}>
          {children}
        </Box>
        <Show if={showFooter}>
          <Footer />
        </Show>
      </Flex>
    </>
  );
};
